import React from 'react';
import { resolveActivityType, FLIK_FALLBACK } from './activityTypes';
import { flikMarkImgStyle } from '../components/Logo/flikMark';

/**
 * Renders an activity type's line icon (FLIK "ICONOS DE ACTIVIDAD" set) on the
 * shared 24×24 grid: stroke 1.75, butt caps, miter joins, no fill. The stroke
 * uses `currentColor` so the icon inherits the colour of the text it sits with
 * (cream on dark surfaces, roca-900 on cream), exactly as the system prescribes.
 * Unknown types fall back to the FLIK mark.
 */
function ActivityTypeIcon({ activityType, size = 16, className }) {
  const type = resolveActivityType(activityType);

  // The FLIK fallback is the brand mark, rendered straight from its PNG (cropped
  // to content) rather than a drawn path — so it can't inherit currentColor.
  if (type.key === FLIK_FALLBACK.key) {
    return <span className={className} style={flikMarkImgStyle(size)} aria-hidden="true" />;
  }

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      aria-hidden="true"
    >
      <path d={type.path} />
    </svg>
  );
}

export default ActivityTypeIcon;
